export default __webpack_public_path__ + "static/homeoffice@2x-db6c3e75e42ef7e9515bf59b109a3e40.webp";